import {UserAgent} from "@/model/user_agent";
import {api} from "@/lib/api";
import {message} from "ant-design-vue";

export class AgentWallet {
    constructor(readonly userAgent: UserAgent) {
    }

    orderQR(amount: number): Promise<string> {
        const done = message.loading('下单中')
        return api<void, any>({url: 'user/wallet/recharge', params: {amount}}).then(res => {
            return res.code_url
        }).finally(done);
    }
}